import React from "react";

const Tabs = ({ tabs, setActiveTab, activeTab }) => {
  return (
    <div className="flex gap-5 md:gap-0 items-center justify-between md:justify-start my-5 whitespace-nowrap  w-full border-b-[0.2px] border-[#A6A6A6] ">
      {tabs.map((item, index) => (
        <div
          onClick={() => setActiveTab(item)}
          key={index}
          className={
            activeTab === item
              ? "md:mr-6 py-1 md:py-3 text-sm hover:border-b-4 hover:border-[#FF6A3A] text-[#FF6A3A]  border-b-4 border-[#FF6A3A] cursor-pointer"
              : "md:mr-6 py-1 md:py-3 text-[#848484] text-sm border-b-1 hover:border-b-4 hover:border-[#FF6A3A] cursor-pointer"
          }
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default Tabs;
